import {
  firestore,
  getDoc,
  doc,
  where,
  collection,
  getDocs,
  query
} from '../../utils/firestore'
import {
  locationCollectionName
} from '../common/appConstants'

export const getDistrict = async (district) => {
  const districtDoc = await getDoc(doc(firestore, locationCollectionName, district))
  return districtDoc.data()
}

export const getCountry = async (countryName) => {
  const country = await getDocs(query(collection(firestore, 'countries'),
    where('countryName', '==', countryName)))
  let countryRec
  country.forEach(doc => {
    countryRec = doc
  })
  return countryRec
}